import axiosInstance from "../utils/axios";

/**
 * Gets paginated LTI integrations, or the full list when exportStatus is true. 
* @param {object} data List filters, pagination and export flag.
 * @param {object} cancelToken Axios cancel token.
 * @returns {Promise} Integrations list response
 */
export const GetLtiIntegrations = async (data, cancelToken) => {
    return await axiosInstance().post("/getLtiIntegrations", data, { cancelToken });
};

/**
 * Gets details for one LTI integration.
 * @param {string|number} id Integration id.
 * @param {object} cancelToken Axios cancel token.
 * @returns {Promise} Integration detail response
 */
export const GetLtiIntegrationDetail = async (id, cancelToken) => {
    return await axiosInstance().get("/getLtiIntegrationDetail", {
        params: { id },
        cancelToken,
    });
};

/**
 * Creates a new LTI integration.
 * @param {object} values Create form payload.
 * @returns {Promise} Create response
 */
export const AddLtiIntegration = async (values) => {
    return await axiosInstance().post("/addLtiIntegration", values);
};

/**
 * Updates an existing LTI integration.
 * @param {object} values Edit form payload.
 * @returns {Promise} Update response
 */
export const EditLtiIntegration = async (values) => {
    return await axiosInstance().post("/editLtiIntegration", values);
};

/**
 * Starts an authenticated Platform to Tool LTI launch.
 * @param {object} values Launch payload with integration id and target URL.
 * @returns {Promise} Launch response with Tool login URL
 */
export const InitiateLtiLaunch = async (values) => {
    return await axiosInstance().post("/initiateLtiLaunch", values);
};

/**
 * Tests the connection for one LTI integration.
 * @param {string|number} id Integration id.
 * @returns {Promise} Test connection response
 */
export const TestLtiIntegration = async (id) => {
    return await axiosInstance().post("/testLtiIntegration", { id });
};

/**
 * Gets resources from the integrated LTI platform.
 * @param {string|number} id Integration id.
 * @param {object} cancelToken Axios cancel token.
 * @returns {Promise} Resources list response
 */
export const GetLtiIntegrationResources = async (id, cancelToken) => {
    return await axiosInstance().get("/getLtiIntegrationResources", {
        params: { id },
        cancelToken,
    });
};

/**
 * Deletes one LTI integration.
 * @param {object} values Delete payload with integrationId.
 * @returns {Promise} Delete response
 */
export const DeleteLtiIntegration = async (values) => {
    return await axiosInstance().post("/deleteLtiIntegration", values);
};

/**
 * Gets paginated LTI integrations audit trail.
 * @param {object} values Audit trail filters and pagination.
 * @param {object} cancelToken Axios cancel token.
 * @returns {Promise} Audit trail list response
 */
export const GetLtiIntegrationAuditTrail = async (values, cancelToken) => {
    return await axiosInstance().post("/getLtiIntegrationAuditTrail", values, {
        cancelToken,
    });
};

/**
 * Gets filter dropdown data for the LTI integrations audit trail.
 * @param {object} params Audit trail filter query params.
 * @param {object} cancelToken Axios cancel token.
 * @returns {Promise} Audit trail filters response
 */
export const GetLtiIntegrationAuditTrailFilters = async (params, cancelToken) => {
    return await axiosInstance().get("/getLtiIntegrationAuditTrailFilters", {
        params,
        cancelToken,
    });
};
